import { render, staticRenderFns } from "./VTicketNew.vue?vue&type=template&id=896f74c2&"
import script from "./VTicketNew.vue?vue&type=script&lang=js&"
export * from "./VTicketNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports